/**
 * Group flat formatted progress photo rows (from useClientPhotos.formatPhotosForDisplay)
 * into timeline groups, sorted **newest first** by group date.
 *
 * @param {Array<{
 *   id: string,
 *   groupId: string,
 *   type: string,
 *   displayName?: string,
 *   url: string,
 *   date: Date,
 *   configuration?: Array<{ id: string, index: number }>,
 * }>} photos
 * @param {string | null | undefined} _referenceGroupId - reserved for callers; does not affect sort order
 * @returns {Array<{
 *   groupId: string,
 *   date: Date,
 *   photos: typeof photos,
 *   configuration: Array | null,
 * }>}
 */
export function groupFormattedPhotosIntoGroups(photos, _referenceGroupId) {
  if (!photos || photos.length === 0) return [];

  const photosByGroup = {};
  photos.forEach((photo) => {
    if (!photo.groupId) return;
    if (!photosByGroup[photo.groupId]) {
      photosByGroup[photo.groupId] = {
        groupId: photo.groupId,
        date: photo.date,
        photos: [],
        configuration: photo.configuration || null,
      };
    }
    photosByGroup[photo.groupId].photos.push(photo);
  });

  const groupsArray = Object.values(photosByGroup);
  groupsArray.sort((a, b) => new Date(b.date) - new Date(a.date));

  groupsArray.forEach((group) => {
    if (group.photos.length > 0 && group.photos[0].configuration) {
      const config = group.photos[0].configuration;
      group.photos.sort((a, b) => {
        const configA = config.find((c) => c.id === a.type);
        const configB = config.find((c) => c.id === b.type);
        const indexA = configA ? configA.index : 999;
        const indexB = configB ? configB.index : 999;
        return indexA - indexB;
      });
    }
  });

  return groupsArray;
}
